import { AuthUser, AUTH_STORAGE_KEYS } from '../../auth/types';
import { AVAILABLE_ROLES } from './roles';

// Global reference to the current user from auth context
let activeAuthUser: AuthUser | null = null;

export const setActiveAuthUser = (user: AuthUser | null) => {
  activeAuthUser = user;
};

// For backward compatibility with old Keycloak-based code
// This is a no-op now but keeps the interface stable
export const setActiveKeycloakInstance = (_instance: unknown) => {
  // No-op - keeping for backward compatibility during migration
};

const getRoles = (): string[] => {
  // First try to get from the active user set by the provider
  if (activeAuthUser) {
    return [activeAuthUser.role];
  }

  // Fall back to reading from localStorage
  const userStr = localStorage.getItem(AUTH_STORAGE_KEYS.USER);
  if (userStr) {
    try {
      const user: AuthUser = JSON.parse(userStr);
      if (user.role) {
        return [user.role];
      }
    } catch (e) {
      console.warn('[getPermission] Failed to parse stored user:', e);
    }
  }

  // Default to agent role if nothing found
  return [AVAILABLE_ROLES.AGENT];
};

export const getPermission = (rules: string[]) => {
  const roles = getRoles();

  return rules.some((rule) => {
    return roles.includes(rule);
  });
};
